/**
 * 每分钟整体重算一次的「当前时间」：时间文案（会话列表时间列、日期分隔条的
 * 今天/昨天）跟着走，避免长开页面跨分钟/跨天不更新。8d-2 建于 ConversationList，
 * 9e-1 抽出共享给 MessageList。
 */
import { useEffect, useState } from 'preact/hooks';

export function useNowMinute(): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 60_000);
    return () => clearInterval(id);
  }, []);
  return now;
}
